var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4111 4.41058C14.7365 4.08514 15.264 4.08514 15.5895 4.41058C15.9149 4.73602 15.9149 5.26353 15.5895 5.58897L11.1786 9.99977L15.5895 14.4106C15.9149 14.736 15.9149 15.2635 15.5895 15.589C15.264 15.9144 14.7365 15.9144 14.4111 15.589L10.0003 11.1782L5.58946 15.589C5.26402 15.9144 4.73651 15.9144 4.41107 15.589C4.08563 15.2635 4.08563 14.736 4.41107 14.4106L8.82188 9.99977L4.41107 5.58897C4.08563 5.26353 4.08563 4.73602 4.41107 4.41058C4.73651 4.08514 5.26402 4.08514 5.58946 4.41058L10.0003 8.82139L14.4111 4.41058Z",
    fill: "#707070"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.05a3ee486c9be05575254eed15b2c04d.svg";